var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React, { forwardRef } from 'react';
import clsx from 'clsx';
import { Badge } from '../Badge/index.js';
import { Icon } from '../Icon/index.js';
import { SelectorIcon, XIcon } from '../icons/index.js';
import { useFloatingContext } from '../utils/floating/index.js';
import { useMultiselect } from './MultiselectContext.js';
export const MultiselectButton = forwardRef((props, ref) => {
    const { children, className, placeholder, dense = false, leadingIcon } = props, rest = __rest(props, ["children", "className", "placeholder", "dense", "leadingIcon"]);
    const { inputValue, searchable, disabled, invalid, isOpen, getComboboxProps, getInputProps, getDropdownProps, getToggleButtonProps, setSelectedItems, selectedItems, reset, } = useMultiselect();
    const { reference } = useFloatingContext();
    const onKeyDown = event => {
        if (event.key === 'Backspace' && !inputValue) {
            setSelectedItems(selectedItems.slice(0, selectedItems.length - 1));
            reset();
        }
        if (event.key === 'Escape') {
            event.stopPropagation();
        }
    };
    return (React.createElement("div", { ref: reference },
        React.createElement("div", Object.assign({ className: clsx('block w-full rounded-md group relative', 'bg-surface-50 text-basicSurface-500', 'py-2 text-left cursor-default', !dense && 'pl-3 pr-10', !disabled &&
                'focus:outline-none focus-visible:ring focus-within:ring-actionPrimary-500 focus-within:border-actionPrimary-500', !invalid && !dense && 'border border-basicSurface-300/25', invalid &&
                'border border-danger-300 text-danger-900 placeholder-danger-300 focus:outline-none focus:ring-danger-500 focus:border-danger-500', 'text-basicSurface-500 bg-surface-50', disabled && 'opacity-60 cursor-default', className) }, getComboboxProps(getToggleButtonProps(Object.assign({ disabled, ref }, rest)))),
            React.createElement("span", { className: "block truncate" },
                React.createElement("div", { className: "flex flex-wrap -ml-2 -mt-2" },
                    leadingIcon && (React.createElement(Icon, { className: clsx('ml-2 mt-2', 'h-5 w-5', !!children && 'mr-1') }, leadingIcon)),
                    children,
                    React.createElement("input", Object.assign({ className: clsx('placeholder-basicSurface-300/75 focus:outline-none bg-transparent flex-1 ml-2 mt-2', !searchable && ' caret-transparent') }, getInputProps(Object.assign(Object.assign({}, getDropdownProps({
                        preventKeyAction: isOpen,
                    })), { placeholder,
                        disabled,
                        onKeyDown })), { readOnly: !searchable })))),
            !dense && (React.createElement("span", { className: "absolute inset-y-0 right-0 flex items-center pr-2 pointer-events-none", "aria-label": "toggle menu" },
                React.createElement(SelectorIcon, { className: "w-5 h-5 text-basicSurface-400", "aria-hidden": "true" }))))));
});
export const MultiselectSelectedItem = props => {
    const { value, index, children, className } = props, rest = __rest(props, ["value", "index", "children", "className"]);
    const { removeSelectedItem, getSelectedItemProps } = useMultiselect();
    return (React.createElement(Badge, Object.assign({ rounded: true, trailingIcon: React.createElement(Badge.Button, { onClick: e => {
                e.stopPropagation();
                removeSelectedItem(value);
            } },
            React.createElement("span", { className: "sr-only" }, "Remove option"),
            React.createElement(Icon, { className: "h-2 w-2" },
                React.createElement(XIcon, null))), className: clsx('ml-2 mt-2 truncate', className) }, rest, getSelectedItemProps({ selectedItem: value, index })),
        React.createElement("div", { className: "truncate" }, children)));
};
//# sourceMappingURL=MultiselectButton.js.map